/*
 * VTee ウィッシュリスト(Swym) 販売開始前ガード
 * ─ ウィッシュリストの各商品について /products/{handle}?view=presale で
 *   「販売開始前(custom.release_at が未来)」かを問い合わせ、販売開始前なら
 *   「カートに追加」ボタンを無効化・ラベル差し替え・クリック阻止する。
 * ─ 最終防衛として /cart/add(.js) の fetch / XHR も横取りし、販売開始前バリアントの
 *   追加リクエストを拒否する。
 * ─ Swym はクライアント側で非同期描画・再描画するため MutationObserver で監視。
 * ─ セレクタが合わない/エンドポイントが無い場合は「何もしない」= 既存を壊さない設計。
 */
(function () {
  'use strict';

  var LABEL = '販売開始前';
  var MSG = '販売開始前の商品はカートに追加できません';
  var ITEM_SEL = 'swym-storefront-layout-item';
  var BTN_SEL = '.swym-storefront-layout-grid-item-add-to-cart-button, [data-action="add-to-cart"]';

  var handleCache = {};        // handle -> Promise<boolean>
  var presaleVariants = {};    // variantId(string) -> true

  function checkPresale(handle) {
    if (handleCache[handle]) return handleCache[handle];
    handleCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=presale', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { try { return !!JSON.parse(t).presale; } catch (e) { return false; } })
      .catch(function () { return false; });
    return handleCache[handle];
  }

  function handleFromItem(item) {
    var du = item.getAttribute('data-du') || '';
    var m = du.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function blockButton(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('data-vtee-presale-blocked', '1');
    var txt = (btn.textContent || '').trim();
    // 「カートに追加 / カートに追加済み」のみラベル差し替え。「売り切れ」等は尊重
    if (txt.indexOf('カートに追加') === 0) btn.textContent = LABEL;
  }

  function applyToItem(item) {
    if (item.getAttribute('data-vtee-presale-checked') === '1') {
      // すでに販売開始前と判定済みなら再描画対策でボタンを再ブロック
      if (item.getAttribute('data-vtee-presale') === '1') {
        blockButton(item.querySelector(BTN_SEL));
      }
      return;
    }
    var handle = handleFromItem(item);
    if (!handle) return;
    item.setAttribute('data-vtee-presale-checked', '1');
    var variantId = item.getAttribute('data-epi');
    checkPresale(handle).then(function (presale) {
      if (!presale) return;
      item.setAttribute('data-vtee-presale', '1');
      if (variantId) presaleVariants[String(variantId)] = true;
      blockButton(item.querySelector(BTN_SEL));
    });
  }

  function scan() {
    var items = document.querySelectorAll(ITEM_SEL);
    Array.prototype.forEach.call(items, applyToItem);
  }

  // ─ クリック阻止 (capture): 販売開始前アイテムの add-to-cart クリックを止める
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var btn = t && t.closest ? t.closest(BTN_SEL) : null;
      if (!btn) return;
      var item = btn.closest(ITEM_SEL);
      var blocked = btn.getAttribute('data-vtee-presale-blocked') === '1' || (item && item.getAttribute('data-vtee-presale') === '1');
      if (blocked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toast();
      }
    },
    true
  );

  // ─ /cart/add(.js) 横取り: 販売開始前バリアントの追加を拒否 (最終防衛)
  function extractVariantId(body) {
    try {
      if (!body) return null;
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') { var j = JSON.parse(body); return j.id || (j.items && j.items[0] && j.items[0].id) || null; }
        var p = new URLSearchParams(body); return p.get('id');
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.get('id');
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.get('id');
    } catch (e) {}
    return null;
  }
  function isBlockedBody(body) {
    var vid = extractVariantId(body);
    return vid && presaleVariants[String(vid)];
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && isBlockedBody(init.body)) {
          toast();
          return Promise.reject(new Error('vtee-presale-blocked'));
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }
  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__vteeUrl = url;
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      try {
        if (this.__vteeUrl && /\/cart\/add(\.js)?(\?|$)/.test(this.__vteeUrl) && isBlockedBody(body)) {
          toast();
          return; // 送信しない
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  }

  // ─ 簡易トースト
  var toastTimer = null;
  function toast() {
    var el = document.getElementById('vtee-presale-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'vtee-presale-toast';
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);z-index:99999;' +
        'background:#333;color:#fff;padding:12px 20px;border-radius:32px;font-size:14px;' +
        'box-shadow:0 4px 16px rgba(0,0,0,.25);opacity:0;transition:opacity .2s ease;pointer-events:none;max-width:90vw;text-align:center;';
      document.body.appendChild(el);
    }
    el.textContent = MSG;
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.style.opacity = '0'; }, 2600);
  }

  function start() {
    scan();
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(); return; }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
